import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w-full h-full flex justify-center items-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VueApexCharts = _resolveComponent("VueApexCharts")!

  return (!_ctx.programmingCategoryRatingPresenter.hasData.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.$t('message.noData')), 1))
    : (_openBlock(), _createBlock(_component_VueApexCharts, {
        key: 1,
        height: "100%",
        options: _ctx.programmingCategoryRatingPresenter.chartOptions.value,
        series: _ctx.programmingCategoryRatingPresenter.chartSeries.value,
        type: "radar"
      }, null, 8, ["options", "series"]))
}